import React from 'react';
import Stack, { StackProps } from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import * as Device from 'react-device-detect';

import { WrapperContext } from './Wrapper';

export interface BodyProps {
  children: React.ReactNode;
  disablePadding?: boolean;
  disabledBackground?: boolean;
  sx?: StackProps['sx'];
}

export const Body = (props: BodyProps) => {
  const context = React.useContext(WrapperContext);

  if (!context) {
    throw new Error('Wrapper.Body must be used inside Wrapper');
  }

  const { managingType, isManaging, setIsManaging } = context;
  const { disablePadding, disabledBackground, children } = props;
  const bodyAnchorRef = React.useRef<HTMLDivElement>(null);
  const theme = useTheme();

  React.useEffect(() => {
    if (isManaging !== managingType) return;

    const timeout = window.setTimeout(() => {
      bodyAnchorRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }, 150);

    return () => window.clearTimeout(timeout);
  }, [isManaging]);

  return (
    <Stack
      ref={bodyAnchorRef}
      m={0}
      p={isManaging === managingType && disablePadding ? 0 : Device.isMobileOnly ? 2 : 3}
      backgroundColor={isManaging === managingType && disabledBackground ? undefined : 'background.paper'}
      sx={{ borderRadius: theme.borderRadius, ...props.sx }}
    >
      {children}
    </Stack>
  );
};
